import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { permissionActions as actions, notificationActions } from '../actions';
import { permissionServices } from '../services';


/* Create Permission Sagas */
function* handleCreatePermissionRequest() {
    const action = yield take(actions.createPermissionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(permissionServices.createPermission, dataParams);
        if (res.isError) {
            yield put(actions.createPermissionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
            // yield put(notificationActions.notificationError({ message: res?.errorMessage, alertType: "error" }));
        } else {
            yield put(actions.createPermissionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createPermissionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Add Access Route Sagas */
function* handleAddAccessRouteRequest() {
    const action = yield take(actions.addAccessRouteRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(permissionServices.addAccessRoute, dataParams);
        if (res.isError) {
            yield put(actions.addAccessRouteError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
            // yield put(notificationActions.notificationError({ message: res?.errorMessage, alertType: "error" }));
        } else {
            yield put(actions.addAccessRouteSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addAccessRouteError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Routes Sagas */
function* handleGetAllRoutesRequest() {
    const action = yield take(actions.getAllRoutesRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(permissionServices.getAllRoutes, dataParams);
        if (res.isError) {
            yield put(actions.getAllRoutesError(res));
        } else {
            yield put(actions.getAllRoutesSuccess(res));
        }
    } catch (error) {
        yield put(actions.getAllRoutesError());
    }
}

/* Get Routes Permission Sagas */
function* handleGetRoutesPermissionRequest() {
    const action = yield take(actions.getRoutesPermissionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(permissionServices.getRoutesPermission, dataParams);
        if (res.isError) {
            yield put(actions.getRoutesPermissionError(res));
        } else {
            yield put(actions.getRoutesPermissionSuccess(res));
        }
    } catch (error) {
        yield put(actions.getRoutesPermissionError());
    }
}

/* Get Menu Permission Sagas */
function* handleGetMenuPermissionRequest() {
    const action = yield take(actions.getMenuPermissionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(permissionServices.getMenuPermission, dataParams);
        if (res.isError) {
            yield put(actions.getMenuPermissionError(res));
        } else {
            yield put(actions.getMenuPermissionSuccess(res));
        }
    } catch (error) {
        yield put(actions.getMenuPermissionError());
    }
}

/* Get Menu Routes Permission Sagas */
function* handleGetMenuRoutesPermissionRequest() {
    const action = yield take(actions.getMenuRoutesPermissionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(permissionServices.getMenuRoutesPermission, dataParams);
        if (res.isError) {
            yield put(actions.getMenuRoutesPermissionError(res));
        } else {
            yield put(actions.getMenuRoutesPermissionSuccess(res));
        }
    } catch (error) {
        yield put(actions.getMenuRoutesPermissionError());
    }
}

/* Get Permission Constant Sagas */
function* handleGetPermissionConstantRequest() {
    const action = yield take(actions.getPermissionConstantRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(permissionServices.getPermissionConstant, dataParams);
        if (res.isError) {
            yield put(actions.getPermissionConstantError(res));
        } else {
            yield put(actions.getPermissionConstantSuccess(res));
        }
    } catch (error) {
        yield put(actions.getPermissionConstantError());
    }
}


/* Get Category Wise Permission Sagas */
function* handleGetCategoryWisePermissionRequest() {
    const action = yield take(actions.getCategoryWisePermissionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(permissionServices.getCategoryWisePermission, dataParams);
        if (res.isError) {
            yield put(actions.getCategoryWisePermissionError(res));
        } else {
            yield put(actions.getCategoryWisePermissionSuccess(res));
        }
    } catch (error) {
        yield put(actions.getCategoryWisePermissionError());
    }
}

/* Update Permission Sagas */
function* handleUpdatePermissionRequest() {
    const action = yield take(actions.updatePermissionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(permissionServices.updatePermission, dataParams);
        if (res.isError) {
            yield put(actions.updatePermissionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updatePermissionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updatePermissionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Role Or User Wise Permission Sagas */
function* handleGetRoleOrUserWisePermissionRequest() {
    const action = yield take(actions.getRoleOrUserWisePermissionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(permissionServices.getRoleOrUserWisePermission, dataParams);
        if (res.isError) {
            yield put(actions.getRoleOrUserWisePermissionError(res));
        } else {
            yield put(actions.getRoleOrUserWisePermissionSuccess(res));
        }
    } catch (error) {
        yield put(actions.getRoleOrUserWisePermissionError());
    }
}

/* Get Notification Event Sagas */
function* handleGetNotificationEventRequest() {
    const action = yield take(actions.getNotificationEventRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(permissionServices.getNotificationEvents, dataParams);
        if (res.isError) {
            yield put(actions.getNotificationEventError(res));
        } else {
            yield put(actions.getNotificationEventSuccess(res));
        }
    } catch (error) {
        yield put(actions.getNotificationEventError());
    }
}

/* Update Communication Sagas */
function* handleUpdateCommunicationRequest() {
    const action = yield take(actions.updateCommunicationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(permissionServices.updateCommunication, dataParams);
        if (res.isError) {
            yield put(actions.updateCommunicationError(res));
        } else {
            yield put(actions.updateCommunicationSuccess(res));
        }
    } catch (error) {
        yield put(actions.updateCommunicationError());
    }
}



/*-----------Watchers-------------*/
function* handleCreatePermissionWatcher() {
    yield takeEvery(
        actions.createPermissionRequest,
        handleCreatePermissionRequest,
    );
}

function* handleAddAccessRouteWatcher() {
    yield takeEvery(
        actions.addAccessRouteRequest,
        handleAddAccessRouteRequest,
    );
}

function* handleGetAllRoutesWatcher() {
    yield takeEvery(
        actions.getAllRoutesRequest,
        handleGetAllRoutesRequest,
    );
}

function* handleGetRoutesPermissionWatcher() {
    yield takeEvery(
        actions.getRoutesPermissionRequest,
        handleGetRoutesPermissionRequest,
    );
}

function* handleGetMenuPermissionWatcher() {
    yield takeEvery(
        actions.getMenuPermissionRequest,
        handleGetMenuPermissionRequest,
    );
}

function* handleGetMenuRoutesPermissionWatcher() {
    yield takeEvery(
        actions.getMenuRoutesPermissionRequest,
        handleGetMenuRoutesPermissionRequest,
    );
}

function* handleGetPermissionConstantWatcher() {
    yield takeEvery(
        actions.getPermissionConstantRequest,
        handleGetPermissionConstantRequest,
    );
}

function* handleGetCategoryWisePermissionWatcher() {
    yield takeEvery(
        actions.getCategoryWisePermissionRequest,
        handleGetCategoryWisePermissionRequest,
    );
}

function* handleUpdatePermissionWatcher() {
    yield takeEvery(
        actions.updatePermissionRequest,
        handleUpdatePermissionRequest,
    );
}

function* handleGetRoleOrUserWisePermissionWatcher() {
    yield takeEvery(
        actions.getRoleOrUserWisePermissionRequest,
        handleGetRoleOrUserWisePermissionRequest,
    );
}

function* handleGetNotificationEventWatcher() {
    yield takeEvery(
        actions.getNotificationEventRequest,
        handleGetNotificationEventRequest,
    );
}

function* handleUpdateCommunnicationWatcher() {
    yield takeEvery(
        actions.updateCommunicationRequest,
        handleUpdateCommunicationRequest,
    );
}






function* rootPermissionSaga() {
    yield all([
        handleCreatePermissionRequest(),
        handleCreatePermissionWatcher(),

        handleAddAccessRouteRequest(),
        handleAddAccessRouteWatcher(),

        handleGetAllRoutesRequest(),
        handleGetAllRoutesWatcher(),

        handleGetRoutesPermissionRequest(),
        handleGetRoutesPermissionWatcher(),

        handleGetMenuPermissionRequest(),
        handleGetMenuPermissionWatcher(),

        handleGetMenuRoutesPermissionRequest(),
        handleGetMenuRoutesPermissionWatcher(),

        handleGetPermissionConstantRequest(),
        handleGetPermissionConstantWatcher(),

        handleGetCategoryWisePermissionRequest(),
        handleGetCategoryWisePermissionWatcher(),

        handleUpdatePermissionRequest(),
        handleUpdatePermissionWatcher(),

        handleGetRoleOrUserWisePermissionRequest(),
        handleGetRoleOrUserWisePermissionWatcher(),
        
        handleGetNotificationEventRequest(),
        handleGetNotificationEventWatcher(),

        handleUpdateCommunicationRequest(),
        handleUpdateCommunnicationWatcher()


    ]);
}

export default rootPermissionSaga;
